import React, { useState, useImperativeHandle } from 'react';
import { Form } from 'react-bootstrap';
import '../sharedFormControl.css'
import NumberFormat from 'react-number-format';
import { validateMobileNumber } from '../../../../../../commonservices/CommonAPICalls';

import smallInfoicon from '../../../../../../assets/images/info-icon-v2.svg'


const PhoneNumberField = (props, ref) => {
    const [validPhoneNumber,setValidPhoneNumber]= useState('');


    useImperativeHandle(ref, () => ({ isValid }), [props.value]);

    const isValid = () => {

        if (props.required && props.value && props.value.length === 10)
            return true;
        else if (props.required && (!props.value || (props.value && props.value.length !== 10)))
            return false;

        return true;

    }

    const onChange = (val) => {

        if (props.onChange)
            props.onChange(props.objectKey, val);

    }

    return (
        <React.Fragment>
            <fieldset className='default-fieldset'>
                {!props.hideLegend ? <legend className='default-fieldset-label'>{props.label ? props.label : 'Phone Number'}</legend> : null}
                <NumberFormat
                    required={props.required}
                    name="dealershipPhoneNumber"
                    placeholder="(000) 000-0000"
                    value={props.value ? props.value : ''}
                    format='(###) ###-####'
                    onValueChange={(values) => onChange(values.value)}
                    disabled={props.disabled}
                    onBlur={async () => {
                      if (props?.value){
                        const validated = await validateMobileNumber(props.value)
                        if(validated){
                            setValidPhoneNumber(validated)
                        }
                        else{
                            setValidPhoneNumber('')
                        }
                      }
                    }}
                />
            </fieldset>
            {/* <Form.Control.Feedback type="invalid">
                {props.errorMessage ? props.errorMessage : `Please enter a valid ${props.name}.`}
            </Form.Control.Feedback> */}
            {props.required && props.validated && !isValid() ? <span className='input-error-message'>{props.errorMessage ? props.errorMessage : `Please enter a valid ${props.name}.`}</span> : (validPhoneNumber === 'success' ? null : (
    <small>
      {validPhoneNumber ? (
        <>
          <img className='common-info-icon' src={smallInfoicon} alt="info" /> {validPhoneNumber}
        </>
      ) : (
        <>
          {props?.infoMessage && (
            <>
              <img className='common-info-icon' src={smallInfoicon} /> {props?.infoMessage}
            </>
          )}
        </>
      )}
    </small>
  ))}
        </React.Fragment>
    )

}


  

export default React.forwardRef(PhoneNumberField);